import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLuggageStorageinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 17,
				y: 15,
				width: 30,
				height: 37,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24.5,
				cy: 54.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 39.5,
				cy: 54.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("path", { d: "M23 21h18m-14 9v13m10-13v13M30 5v7" }),
			/* @__PURE__ */ _jsx("rect", {
				x: 25,
				y: 1,
				width: 14,
				height: 4,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", { d: "M34 5v7m25 25v18a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V37" })
		]
	})
});
export default SvgLuggageStorageinline;
